<template>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：絞り込み条件画面(ファイル管理)画面(STFMFM02C10)                                                                    _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
  <div
    class="overlay"
    :class="[isShow ? showClass : hideClass]"
    id="popup-filtering"
    data-role="popup-close"
    data-popup-width="1250"
  >
    <div class="popup" style="width: 1160px">
      <div class="popup-head">絞り込み条件</div>
      <div class="popup-body blue">
        <!--
          ****  メッセージ表示領域 ****
          -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p :style="{ 'margin-top': errors.length > 0 ? '20px' : '' }">
          絞り込み条件を設定してください。
        </p>
        <div style="height: 360px; overflow-y: scroll">
          <div v-if="filterViewsDisplay.ClassificationControlBusinessInfo">
            <div
              :class="[
                filterViewsDisplay.DisplayFlagsBusiness?.title ? 'para' : '',
              ]"
            >
              <div class="frm-row">
                <span
                  class="frm-label w-140px"
                  >検索キーワード</span
                >
                <div class="frm-search frm-size-keyword">
                  <span class="frm-label">
                    &nbsp;
                    <img src="@/assets/images/TDSDC/icon_search.png" />
                  </span>
                  <input
                    tabindex="1"
                    type="search"
                    id="search"
                    ref="search"
                    name="searchBox"
                    v-model.trim="searchKey"
                    placeholder="検索キーワード"
                    maxlength="255"
                    size="84"
                    class="frm-search-text"
                  />
                </div>
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.BusinessCode"
              >
                <span class="frm-label w-140px">事業者コード</span>
                <select
                  tabindex="2"
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.CompanyCodeCondition"
                  @change="handleBopCodeChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  tabindex="3"
                  title=" "
                  type="url"
                  class="frm-text frm-size-xxml"
                  maxlength="10"
                  v-model.trim="businessInfoArea.CompanyCode"
                  :disabled="isBopCodeDisabled"
                  :class="{ error: businessInfoArea.isErrorBopCode }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 150px"
                v-show="businessInfoArea.isErrorBopCodeMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorBopCodeMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.BusinessName"
              >
                <span class="frm-label w-140px">事業者名</span>
                <select
                  tabindex="4"
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.CompanyNameCondition"
                  @change="handleBopNameChange"
                >
                  <option
                    v-for="item in detailBusinessCodeList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  tabindex="5"
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="businessInfoArea.CompanyName"
                  :disabled="isBopNameDisabled"
                  :class="{ error: businessInfoArea.isErrorBopName }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 150px"
                v-show="businessInfoArea.isErrorBopNameMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorBopNameMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="
                  filterViewsDisplay.DisplayFlagsBusiness
                    .CorporateIndividualClassification
                "
              >
                <span class="frm-label w-140px">法人個人区分</span>
                <select
                  tabindex="6"
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.BusinessOperatorType"
                  @change="handleCorproationDivisionChange"
                  :class="{
                    error: businessInfoArea.isErrorCorproationDivision,
                  }"
                >
                  <option
                    v-for="item in corproationDivisionList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div
                class="frm-row"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.SettlementDate"
              >
                <span class="frm-label w-140px">決算日</span>
                <select
                  tabindex="7"
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.KessanDateCondition"
                  @change="handleDetailDesignatedDateChange"
                >
                  <option
                    v-for="item in detailDesignatedDateList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  tabindex="8"
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailDesignatedDateStartDisabled"
                  v-model="businessInfoArea.KessanDateFromMonth"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{
                    error: businessInfoArea.isErrorKessanDateFromMonth,
                  }"
                />
                <span class="frm-unit">月</span>
                <input
                  tabindex="9"
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  :disabled="isDetailDesignatedDateStartDisabled"
                  v-model="businessInfoArea.KessanDateFromDay"
                  v-show="isShowKessanDateFromDay"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  :class="{ error: businessInfoArea.isErrorKessanDateFromDay }"
                />
                <span class="frm-unit" v-show="isShowKessanDateFromDay"
                  >日</span
                >
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >～</span
                >
                <input
                  tabindex="10"
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  v-show="detailDesignatedDateEndFlag"
                  v-model="businessInfoArea.KessanDateToMonth"
                  :class="{ error: businessInfoArea.isErrorKessanDateToMonth }"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                />
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >月</span
                >
                <input
                  tabindex="11"
                  title=" "
                  type="url"
                  maxlength="2"
                  class="frm-text frm-size-xs alignright"
                  v-show="detailDesignatedDateEndFlag"
                  v-model="businessInfoArea.KessanDateToDay"
                  :class="{ error: businessInfoArea.isErrorKessanDateToDay }"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                />
                <span class="frm-unit" v-show="detailDesignatedDateEndFlag"
                  >日</span
                >
              </div>
              <p
                class="errMsg"
                style="margin-left: 150px"
                v-show="businessInfoArea.isErrorKessanDateMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorKessanDateMsg"
                ></ErrorMessageCase>
              </p>
              <div
                class="frm-row frm-row-margin-top"
                v-if="filterViewsDisplay.DisplayFlagsBusiness.MainCharge"
              >
                <span class="frm-label w-140px">主担当者</span>
                <select
                  tabindex="12"
                  class="frm-select frm-size-l"
                  v-model="businessInfoArea.managerSelected"
                  @change="handleManagerChange"
                >
                  <option
                    v-for="item in managerSelectedCondition"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <input
                  tabindex="13"
                  type="text"
                  class="frm-text frm-size-xxml"
                  maxlength="100"
                  v-model.trim="businessInfoArea.manager"
                  :disabled="isManagerDisabled"
                  :class="{ error: businessInfoArea.isErrorManager }"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 150px"
                v-show="businessInfoArea.isErrorManagerMsg != ''"
              >
                <ErrorMessageCase
                  :errors="businessInfoArea.isErrorManagerMsg"
                ></ErrorMessageCase>
              </p>

            </div>
            <br />
          </div>

        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              tabindex="14"
              class="frm-btn strong large"
              data-role="popup-open"
              data-target="#popup-process"
              ref="searchButton"
              @click="SearchBtn"
            >
              検索
            </button>
            <button
              tabindex="15"
              class="frm-btn large"
              data-role="popup-close"
              @click="CancelBtn"
              @blur="onblur"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Common from "@/util/common";
import {
  DETAIL_BUSINESS_CODE_LIST,
  CORPORATION_DIVISION_LIST,
  DETAIL_DESIGNATED_DATE_LIST,
  FILTER_VIEWS_DISPLAY_FLAG_LIST,
} from "@/util/data.js";
import { LOGININ_SYSTEM_STATUS_INFO } from "@/util/enum.js";
import Validation from "@/util/validation.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import {
  isDate,
} from "@/util/dateFormat.js";
import { API_STFMFM02C01, API_STFMFM02C01_SetFilter} from "@/api/Modules/FM02/STFMFM02C01.js";

export default {
  name: "STFMFM02C10FilterCompleteModal",
  components: { ErrorMessage, ErrorMessageCase },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: false,
    },
    pageId: {
      type: String,
      required: true,
    },
    loginSystem: {
      type: Number,
      required: true,
    },
    keyWordFilterInit: {
      type: String,
      required: true,
    },
    bopDataFilterInit: {
      type: Object,
      required: false,
    },
    STFMFM02C01FilterInit: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      personInChargeList: [],
      personInChargeCopyPageId: [
        "STFMFM02C01"
      ],
      kessanDateCopyPageId: ["STFMFM02C01"],
      errors: [], //エラーメッセージ
      settingCode: "99", //設定中コード
      corproationDivisionList: CORPORATION_DIVISION_LIST, //法人、個人、区分
      detailDesignatedDateList: DETAIL_DESIGNATED_DATE_LIST, //決算日
      filterViewsDisplay: {}, //画面項目制御
      logininSystemStatus: LOGININ_SYSTEM_STATUS_INFO,
      searchKey: this.keyWordFilterInit,
      businessInfoAreaCopy: {},
      declarationFormInfoAreaCopy: {},
      businessInfoArea: {
        CompanyCodeCondition: 0,
        CompanyCode: "",
        isErrorBopCode: false,
        isErrorBopCodeMsg: [], //業者コード
        CompanyNameCondition: 0,
        CompanyName: "",
        isErrorBopName: false,
        isErrorBopNameMsg: [], //事業者名
        BusinessOperatorType: 0,
        corproationDivision: "",
        corproationDivisionFlag: true,
        isErrorCorproationDivision: false, //法人個人区分
        KessanDateCondition: 0,
        KessanDateFromMonth: "",
        KessanDateFromDay: "",
        KessanDateToMonth: "",
        KessanDateToDay: "",
        returnCodeKessanDate: 0,
        isErrorKessanDateFromMonth: false,
        isErrorKessanDateFromDay: false,
        isErrorKessanDateToMonth: false,
        isErrorKessanDateToDay: false,
        isErrorKessanDate: false,
        isErrorKessanDateMsg: [], //決算日
        managerSelected: 0,
        manager: "",
        returnCodeManager: 0,
        isErrorManager: false,
        isErrorManagerMsg: [], //主担当者名
      }, //画面項目設定_事業者情報エリア
    };
  },
  created() {
    this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
      (el) => el.pageId == this.pageId
    )[0];
    this.businessInfoAreaCopy = _.cloneDeep(this.businessInfoArea);
  },
  mounted() {
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
    loginSystem: {
      handler: "filterViewsDisplayFlag",
      immediate: true,
    },
    keyWordFilterInit: {
      handler: "keyWordFilterInitWatch",
      immediate: true,
    },
    bopDataFilterInit: {
      handler: "bopDataFilterInitWatch",
      immediate: true,
      deep: true,
    },
    STFMFM02C01FilterInit: {
      handler: "STFMFM02C01FilterInitWatch",
      immediate: true,
      deep: true,
    },
  },
  computed: {
    //#region チェックボックスとドロップダウンリスト取得
    // **********************************************
    // * 主担当者(ドロップダウンリスト)を取得
    // **********************************************
    managerSelectedCondition() {
      return DETAIL_BUSINESS_CODE_LIST;
    },
    // **********************************************
    // * 事業者コード、事業者名、主担当者名,データ名称,処理データ,申告書等(ドロップダウンリスト)を取得
    // **********************************************
    detailBusinessCodeList() {
      return DETAIL_BUSINESS_CODE_LIST.filter((el) => el.code != 100);
    },
    //#endregion
    //#region 非活性
    // 詳細_事業者コードテキストコントロールを非活性にする
    isBopCodeDisabled() {
      return this.businessInfoArea.CompanyCodeCondition == 0 ? true : false;
    },
    // 詳細_事業者名テキストコントロールを非活性にする
    isBopNameDisabled() {
      return this.businessInfoArea.CompanyNameCondition == 0 ? true : false;
    },
    // 詳細_法人個人区分の設定
    isCorproationDivisionDisabled() {
      return this.businessInfoArea.BusinessOperatorType == 0 ? true : false;
    },
    // 詳細_決算日テキストコントロールを非活性にする
    isDetailDesignatedDateStartDisabled() {
      return this.businessInfoArea.KessanDateCondition == 0 ? true : false;
    },
    // 詳細_主担当者名テキストコントロールを非活性にする
    isManagerDisabled() {
      return this.businessInfoArea.managerSelected == 0 ||
        this.businessInfoArea.managerSelected == 100
        ? true
        : false;
    },
       
    //#region 日付の表示制御
    //決算日
    isShowKessanDateFromDay() {
      return this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[2].code
        ? false
        : true;
    },
    detailDesignatedDateEndFlag() {
      return this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
        ? true
        : false;
    },
    //#endregion
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    //#region 事業者情報エリアのチェンジイベント
    // 詳細フィルタ_事業者コードを取得
    handleBopCodeChange(e) {
      this.businessInfoArea.CompanyCodeCondition = e.target.value;
      if (this.businessInfoArea.CompanyCodeCondition == 0) {
        this.businessInfoArea.CompanyCode = "";
      }
    },
    // 詳細フィルタ_事業者名を取得
    handleBopNameChange(e) {
      this.businessInfoArea.CompanyNameCondition = e.target.value;
      if (this.businessInfoArea.CompanyNameCondition == 0) {
        this.businessInfoArea.CompanyName = "";
      }
    },
    // 詳細フィルタ_法人個人区分を取得
    handleCorproationDivisionChange(e) {
      this.businessInfoArea.BusinessOperatorType = e.target.value;
      if (this.businessInfoArea.BusinessOperatorType == 0) {
        this.businessInfoArea.corproationDivision = "";
      }
    },
    // 詳細_決算日を取得
    handleDetailDesignatedDateChange(e) {
      this.businessInfoArea.KessanDateCondition = e.target.value;
      this.businessInfoArea.KessanDateFromMonth = "";
      this.businessInfoArea.KessanDateFromDay = "";
      this.businessInfoArea.KessanDateToMonth = "";
      this.businessInfoArea.KessanDateToDay = "";
    },
    // 詳細フィルタ_主担当者名を取得
    handleManagerChange(e) {
      this.businessInfoArea.managerSelected = e.target.value;
      if (
        this.businessInfoArea.managerSelected == 0 ||
        this.businessInfoArea.managerSelected == 100
      ) {
        this.businessInfoArea.manager = "";
      }
    },
    //#endregion

    
    // すべての条件をクリア
    handleReset(saveFlg) {
      this.errors = [];
      this.searchKey = "";

      //画面項目設定_事業者情報エリア
      this.businessInfoArea = {
        CompanyCodeCondition: 0,
        CompanyCode: "",
        isErrorBopCode: false,
        isErrorBopCodeMsg: [], //業者コード
        CompanyNameCondition: 0,
        CompanyName: "",
        isErrorBopName: false,
        isErrorBopNameMsg: [], //事業者名
        BusinessOperatorType: 0,
        corproationDivision: "",
        corproationDivisionFlag: true,
        isErrorCorproationDivision: false, //法人個人区分
        KessanDateCondition: 0,
        KessanDateFromMonth: "",
        KessanDateFromDay: "",
        KessanDateToMonth: "",
        KessanDateToDay: "",
        returnCodeKessanDate: 0,
        isErrorKessanDateFromMonth: false,
        isErrorKessanDateFromDay: false,
        isErrorKessanDateToMonth: false,
        isErrorKessanDateToDay: false,
        isErrorKessanDate: false,
        isErrorKessanDateMsg: [], //決算日
        managerSelected: 0,
        manager: "",
        returnCodeManager: 0,
        isErrorManager: false,
        isErrorManagerMsg: [], //主担当者名
      };
      
      // フィルター条件の保存
      if (!saveFlg) {
        this.saveFilter(true);
      }
    },

        //エラーメッセージクリア
    errorsClear() {
      this.errors = [];
      //事業者情報エリア
      this.businessInfoArea.isErrorBopCodeMsg = [];
      this.businessInfoArea.isErrorBopCode = false; //業者コード
      this.businessInfoArea.isErrorBopNameMsg = [];
      this.businessInfoArea.isErrorBopName = false; //事業者名
      //this.businessInfoArea.isErrorCorproationDivision = false; //法人個人区分
      this.businessInfoArea.isErrorKessanDateFromMonth = false;
      this.businessInfoArea.isErrorKessanDateFromDay = false;
      this.businessInfoArea.isErrorKessanDateToMonth = false;
      this.businessInfoArea.isErrorKessanDateToDay = false;
      this.businessInfoArea.isErrorKessanDateMsg = []; //決算日
      this.businessInfoArea.isErrorManager = false;
      this.businessInfoArea.isErrorManagerMsg = []; //主担当者名
    },

    onblur(e) {
      if(!e) return;
      e.preventDefault();
      this.initFocus();
    },
    // **********************************************
    // * ダイアログで検索が選択された時の処理
    // **********************************************
    SearchBtn() {
      this.errorsClear();

      if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
        this.businessInfoAreaCheck();
      }

      if (this.errors.length > 0) {
        //return;
      } else {
        //元画面の連動項目コードを設定
        if (this.kessanDateCopyPageId.includes(this.pageId)) {
          this.returnKessanDateSetting(); //決算日連動
        }
        if (this.personInChargeCopyPageId.includes(this.pageId)) {
          this.returnManagerSetting(); //主担当者連動
        }
      }

      if (this.errors.length > 0) {
        this.errors = [];
        const msg = Common.createError(
          "MTCL1119",
          Common.getMessage("MTCL1119", [])
        );
        this.errors.push(msg);
        return;
      }

      this.saveFilter()
        .then(() => {
          this.$emit("SearchBtn", {
            searchKey: this.searchKey,
            motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
            returnBopDataFilter: this.returnBopDataFilter(), //事業者情報 フィルタ条件
          });
        })
        .catch(()=>{
          return;
        });
    },
    // **********************************************
    // * ダイアログでキャンセルが選択された時の処理
    // **********************************************
    CancelBtn() {
      this.processDialogue(true);
      let keyWordFilterReset = "";
      let bopDataFilterReset = {};
      let apiRequest;
      this.handleReset(true);
      // switch (this.pageId) {
      //   case "STFMFM02C01":
      //     apiRequest = API_STFMFM02C01;
      //     break;

      //   default:
      // }
      // 詳細フィルターを取得する
      API_STFMFM02C01().then((response) => {
        // 保存されているフィルタ条件の適用
        if (response.bopDataFilter && response.bopDataFilter.result != "0001") {
          bopDataFilterReset = response.bopDataFilter;
        }
        if (response.keywordFilter && response.keywordFilter.result != "0001") {
          keyWordFilterReset = response.keywordFilter.searchKey;
        }
        
        this.keyWordFilterInitWatch(keyWordFilterReset);
        this.bopDataFilterInitWatch(bopDataFilterReset);

        this.STFMFM02C01FilterInitWatch(this.STFMFM02C01FilterInit);

        this.processDialogue(false);
        this.$emit("CancelBtn");
      });
    },
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.search.focus();
    },
    
    // **********************************************
    // * フィルタ_DB保存
    // **********************************************
    saveFilter() {
      const keyWordFilter = {
        searchKey: this.searchKey,
        pageID: this.pageId,
      };

      //事業者情報
      const detailBopFilter = this.returnBopDataFilter();

      //#region
      let params = {
        keyWordFilter: keyWordFilter,
        BopDataFilter: null,
      };

      if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
        params.BopDataFilter = detailBopFilter;
      }

      this.errors = [];

      return new Promise((resolve, reject) => {
        // フィルター条件保存処理
        API_STFMFM02C01_SetFilter(params).then((response) => {
          // 正常終了の場合
          if (_.eq(response.result, "0000")) {
            resolve();
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, response.errorParaList)
              )
            );
            reject();
          }
        });
      });
      //#endregion
    },

    //#endregion

    //#region 画面項目をバックエンド項目に設定

    //画面項目をバックエンド項目に設定　事業者情報
    returnBopDataFilter() {
      return {
        pageId: this.pageId,
        businessOperatorCodeOption: this.businessInfoArea.CompanyCodeCondition,
        businessOperatorCode: this.businessInfoArea.CompanyCode, //業者コード
        businessOperatorNameOption: this.businessInfoArea.CompanyNameCondition,
        businessOperatorName: this.businessInfoArea.CompanyName, //事業者名
        businessOperatorType: this.businessInfoArea.BusinessOperatorType,
        //corproationDivision: this.businessInfoArea.corproationDivision, //法人個人区分
        accountClosingOption: this.businessInfoArea.KessanDateCondition,
        accountClosingFromMonth: this.businessInfoArea.KessanDateFromMonth,
        accountClosingFromDay: this.businessInfoArea.KessanDateFromDay,
        accountClosingToMonth: this.businessInfoArea.KessanDateToMonth,
        accountClosingToDay: this.businessInfoArea.KessanDateToDay,
        returnCodeKessanDate: this.businessInfoArea.returnCodeKessanDate, //決算日
        personInChargeOption: this.businessInfoArea.managerSelected,
        returnCodePersonInCharge: this.businessInfoArea.returnCodeManager,
        personInCharge: this.businessInfoArea.manager, //主担当者名
        motoPageHandleShowBtn: this.motoPageHandleShowBtnSetting(), //元画面の詳細条件ボタン設定
      };
    },
    
    //決算日連動
    kessanDateSetting(newVal) {
      if (!newVal) return;
      var accountClosingMonth = newVal; //決算日

      //決算日・指定しないの場合
      if (accountClosingMonth == DETAIL_DESIGNATED_DATE_LIST[0].code) {
        this.businessInfoArea.KessanDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[0].code;
        this.businessInfoArea.KessanDateFromMonth = "";
        this.businessInfoArea.KessanDateFromDay = "";
      } else if (accountClosingMonth == this.settingCode) {
        //処理なし
      } else {
        this.businessInfoArea.KessanDateCondition =
          DETAIL_DESIGNATED_DATE_LIST[2].code;
        this.businessInfoArea.KessanDateFromMonth = accountClosingMonth;
        this.businessInfoArea.KessanDateFromDay = "";
      }
      this.filterCopy();
    },
    //元画面の連動項目コードを設定 決算日連動
    returnKessanDateSetting() {
      var returnCode = 0;
      //決算日・指定しないの場合
      if (
        this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        returnCode = 0;
      } else if (
        this.businessInfoArea.KessanDateCondition ==
        DETAIL_DESIGNATED_DATE_LIST[3].code
      ) {
        returnCode = this.settingCode;
      } else {
        if (this.businessInfoArea.KessanDateFromDay != "") {
          returnCode = this.settingCode;
        } else {
          returnCode = this.businessInfoArea.KessanDateFromMonth;
        }
      }
      this.businessInfoArea.returnCodeKessanDate = Number(returnCode);
    },

    //主担当者連動
    managerSetting(newVal) {
      if (!newVal) return;
      var managerOption = newVal; //主担当者名

      //主担当者名・指定しないの場合
      if (managerOption == DETAIL_BUSINESS_CODE_LIST[0].code) {
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[0].code;
        this.businessInfoArea.manager = "";
      } else if (managerOption == this.settingCode) {
        //詳細指定中
        //処理なし
      } else if (managerOption == DETAIL_BUSINESS_CODE_LIST[3].code) {
        //未設定
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[3].code;
        //処理なし
      } else {
        //画面項目.決算日条件=指定日　かつ　月項目あり、日項目なし
        this.businessInfoArea.managerSelected =
          DETAIL_BUSINESS_CODE_LIST[1].code;
        this.businessInfoArea.manager = managerOption;
      }

      //基本情報.ログインシステム=データ集配信
      // if (
      //   this.loginSystem == this.logininSystemStatus["CollectionDelivery"].code
      // ) {
      //   this.businessInfoArea.manager = ""; //空文字
      // }
      this.filterCopy();
    },
    //元画面の連動項目コードを設定 主担当者連動
    returnManagerSetting() {
      var returnCode = 0;
      //主担当者・指定しないの場合
      if (
        this.businessInfoArea.managerSelected ==
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        returnCode = DETAIL_BUSINESS_CODE_LIST[0].code;
      } else if (
        this.businessInfoArea.managerSelected ==
        DETAIL_BUSINESS_CODE_LIST[3].code
      ) {
        returnCode = DETAIL_BUSINESS_CODE_LIST[3].code;
      } else if (
        this.businessInfoArea.managerSelected ==
          DETAIL_BUSINESS_CODE_LIST[1].code ||
        this.businessInfoArea.managerSelected ==
          DETAIL_BUSINESS_CODE_LIST[2].code
      ) {
        returnCode = this.settingCode;
      }
      
      this.businessInfoArea.returnCodeManager = returnCode;
    },
    

    // **********************************************
    // * 画面項目制御フラグ設定
    // **********************************************
    filterViewsDisplayFlag(newVal) {
      this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
        (el) => el.pageId == this.pageId
      )[0];
      const ProcessingDivisionFlg =
        this.filterViewsDisplay?.DisplayFlagsProcessing?.ProcessingDivisionList;
      

      switch (newVal) {
        //集配信の場合
        case this.logininSystemStatus["CollectionDelivery"].code:
          break;
        case this.logininSystemStatus["Electricity"].code:
          //事業者情報
          if (this.filterViewsDisplay.ClassificationControlBusinessInfo) {
            this.filterViewsDisplay.DisplayFlagsBusiness.MainCharge = true; //主担当者名
          }
          
          break;
        default:
      }
    },
    keyWordFilterInitWatch(newVal) {
      if (this.searchKey !== newVal) {
        this.searchKey = newVal;
      }
    },
    //事業者
    bopDataFilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0 && newVal.result) {
        //事業者コード、条件
        this.businessInfoArea.CompanyCodeCondition =
          newVal.businessOperatorCodeOption;
        //事業者コード、テキスト
        this.businessInfoArea.CompanyCode = newVal.businessOperatorCode;

        //事業者名、条件
        this.businessInfoArea.CompanyNameCondition =
          newVal.businessOperatorNameOption;
        //事業者名、テキスト
        this.businessInfoArea.CompanyName = newVal.businessOperatorName;

        //法人個人区分、条件
        this.businessInfoArea.BusinessOperatorType =
          newVal.businessOperatorType;
        //法人個人区分、テキスト
        //this.businessInfoArea.corproationDivision = newVal.corproationDivision;

        //決算日、条件
        this.businessInfoArea.KessanDateCondition = newVal.accountClosingOption;
        //決算日、条件
        this.businessInfoArea.KessanDateFromMonth =
          newVal.accountClosingFromMonth;
        //決算日、条件
        this.businessInfoArea.KessanDateFromDay = newVal.accountClosingFromDay;
        //決算日、条件
        this.businessInfoArea.KessanDateToMonth = newVal.accountClosingToMonth;
        //決算日、条件
        this.businessInfoArea.KessanDateToDay = newVal.accountClosingToDay;

        //主担当者名、条件
        this.businessInfoArea.managerSelected = newVal.personInChargeOption;
        //主担当者名、テキスト
        this.businessInfoArea.manager = newVal.personInCharge;
      }
    },

    //STFMFM02C01共通フィルタ
    STFMFM02C01FilterInitWatch(newVal) {
      if (newVal && Object.keys(newVal).length > 0) {
        //決算日連動
        this.kessanDateSetting(newVal.accountClosingMonth);

        //主担当者連動
        this.personInChargeList = newVal.personInChargeList;
        this.managerSetting(newVal.personInCharge);
      }
    },
    //#endregion

    //#region 画面項目チェック

    //画面項目設定_事業者情報エリアチェック
    businessInfoAreaCheck() {
      // 事業者コードが「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.CompanyCodeCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // 事業者コード 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.CompanyCodeCondition,
          this.businessInfoArea.CompanyCode,
          "事業者コード"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorBopCodeMsg.push(msg);
          this.businessInfoArea.isErrorBopCode = true;
          //return;
        }
      }
      // 事業者名が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.CompanyNameCondition !=
        DETAIL_BUSINESS_CODE_LIST[0].code
      ) {
        // 事業者名 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.CompanyNameCondition,
          this.businessInfoArea.CompanyName,
          "事業者名"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorBopName = true;
          this.businessInfoArea.isErrorBopNameMsg.push(msg);
          //return;
        }
      }

      // 決算日が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.KessanDateCondition !=
        DETAIL_DESIGNATED_DATE_LIST[0].code
      ) {
        if (
          this.businessInfoArea.KessanDateCondition ==
          DETAIL_DESIGNATED_DATE_LIST[2].code
        ) {
          var msg = this.checkFilterMStart(
            this.businessInfoArea.KessanDateCondition,
            this.businessInfoArea.KessanDateFromMonth,
            "決算日"
          );
          if (msg != "") {
            this.errors.push(msg);
            this.businessInfoArea.isErrorKessanDateFromMonth = true;
            this.businessInfoArea.isErrorKessanDateMsg.push(msg);
          }
        } else {
          // 決算日のチェック
          var msg = this.checkFilterDateMD(
            this.businessInfoArea.KessanDateCondition,
            this.businessInfoArea.KessanDateFromMonth,
            this.businessInfoArea.KessanDateFromDay,
            this.businessInfoArea.KessanDateToMonth,
            this.businessInfoArea.KessanDateToDay,
            "決算日"
          );
          // 入力チェック異常の場合、エラーメッセージ表示
          if (msg != "" && msg != "YearendStraddle") {
            this.errors.push(msg);
            this.businessInfoArea.isErrorKessanDateMsg.push(msg);
            if (
              this.detailDuringDateSelected ==
                DETAIL_DESIGNATED_DATE_LIST[1].code ||
              this.detailDuringDateSelected ==
                DETAIL_DESIGNATED_DATE_LIST[2].code
            ) {
              this.businessInfoArea.isErrorKessanDateFromMonth = true;
              this.businessInfoArea.isErrorKessanDateFromDay = true;
            } else {
              this.businessInfoArea.isErrorKessanDateFromMonth = true;
              this.businessInfoArea.isErrorKessanDateFromDay = true;
              this.businessInfoArea.isErrorKessanDateToMonth = true;
              this.businessInfoArea.isErrorKessanDateToDay = true;
            }
            //return;
          }
        }
      }
      // 主担当者名が「指定しない」以外の場合フィルタする
      if (
        this.businessInfoArea.managerSelected !=
          DETAIL_BUSINESS_CODE_LIST[0].code &&
        this.businessInfoArea.managerSelected !=
          DETAIL_BUSINESS_CODE_LIST[3].code &&
        this.filterViewsDisplay.DisplayFlagsBusiness.MainCharge
      ) {
        // 主担当者名 日付以外(空白非許容)
        var msg = Validation.checkFilterWithOutSpace(
          this.businessInfoArea.managerSelected,
          this.businessInfoArea.manager,
          "主担当者"
        );

        // 入力チェック異常の場合、エラーメッセージ表示
        if (msg != "") {
          this.errors.push(msg);
          this.businessInfoArea.isErrorManagerMsg.push(msg);
          this.businessInfoArea.isErrorManager = true;
          //return;
        }
      }
    },
    //#region Validation.js dateFormat.js

    /**
     * 日付(開始・終了なし)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} month 月
     * @param {*} day 日
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterMDStart(selected, month, day, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 日
        if (day == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 月チェック
        if (!Validation.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
        // 日
        if (day != "") {
          // 日チェック
          if (!this.verifyDate(month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }

          // 月日
          if (!isDate(2000, month, day)) {
            return Common.createError(
              "MTCL1011",
              Common.getMessage("MTCL1011", [label])
            );
          }
        }
      }
      return "";
    },

    /**
     * 日付(開始・終了なし)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} month 月
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterMStart(selected, month, label) {
      // 「指定しない」以外の場合
      if (selected != 0) {
        // 非空、半角数字チェック
        // 月
        if (month == "") {
          return Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", [label])
          );
        }
        // 月チェック
        if (!Validation.isMonth(month)) {
          return Common.createError(
            "MTCL1011",
            Common.getMessage("MTCL1011", [label])
          );
        }
      }
      return "";
    },

    /**
     * 日付(開始・終了あり)　月日項目
     * @param {*} selected 選択条件（0：指定しない／0以外：条件指定）
     * @param {*} monthS 月（開始）
     * @param {*} dayS 日（開始）
     * @param {*} monthE 月（終了）
     * @param {*} dayE 日（終了）
     * @param {*} label 項目名
     * @returns チェック結果（正常：空白／異常：エラーメッセージ）
     */
    checkFilterDateMD(selected, monthS, dayS, monthE, dayE, label) {
      var rtnS = this.checkFilterMDStart(selected, monthS, dayS, label);
      if (rtnS != "") {
        return rtnS;
      }
      if (selected == DETAIL_DESIGNATED_DATE_LIST[3].code) {
        var rtnE = this.checkFilterMDStart(selected, monthE, dayE, label);
        if (rtnE != "") {
          return rtnE;
        }
        if (Number(monthS) > Number(monthE)) {
          return "YearendStraddle";
        } else if (monthS == monthE) {
          if (dayS > dayE) {
            return "YearendStraddle";
          }
        }
      }
      return "";
    },

    /**
     * 日付正誤チェック　月日項目
     * @param {number} month 月
     * @param {number} day 日
     * @returns チェック結果 true  : チェックOK / false : チェックNG
     */
    verifyDate(month, day) {
      if (month > 12 || month < 1) return false;

      if (day > 31 || day < 1) return false;

      if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30)
        return false;

      if (month == 2) {
        if (day > 29) return false;
      }

      return true;
    },
    
    //#region　元画面の詳細条件ボタン設定
    motoPageHandleShowBtnSetting() {
      this.filterCopy();
      let rtnFlg = false;
      const displayFlg = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
        (el) => el.pageId == this.pageId
      )[0];
      if (displayFlg.ClassificationControlBusinessInfo) {
        rtnFlg = this.objKeyValueIsSame(
          this.businessInfoAreaCopy,
          this.businessInfoArea
        );
        if (rtnFlg) return rtnFlg;
        if (
          this.businessInfoArea.returnCodeKessanDate == this.settingCode ||
          this.businessInfoArea.returnCodeManager == this.settingCode
        ) {
          rtnFlg = true;
        }
        if (rtnFlg) return rtnFlg;
      }
      
      return rtnFlg;
    },

    //二つのobjの値が等しいかどうかを確認
    objKeyValueIsSame(obj1, obj2) {
      let keysOne = Object.keys(obj1);
      let keysTwo = Object.keys(obj2);
      let rtnFlg = true;

      for (let key of keysOne) {
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          if (
            !(
              obj1[key].length == obj2[key].length &&
              obj1[key].every((a) => obj2[key].some((b) => a == b)) &&
              obj2[key].every((c) => obj1[key].some((d) => c == d))
            )
          ) {
            rtnFlg = false;
            break;
          }
        } else {
          if (String(obj1[key]) !== String(obj2[key])) {
            rtnFlg = false;
            break;
          }
        }
      }

      return !rtnFlg;
    },

    filterCopy() {
      const {
        KessanDateCondition,
        KessanDateFromMonth,
        KessanDateFromDay,
        KessanDateToMonth,
        KessanDateToDay,
        returnCodeKessanDate,
      } = this.businessInfoArea;
      if (this.kessanDateCopyPageId.includes(this.pageId)) {
        this.businessInfoAreaCopy = {
          ...this.businessInfoAreaCopy,
          ...{
            KessanDateCondition,
            KessanDateFromMonth,
            KessanDateFromDay,
            KessanDateToMonth,
            KessanDateToDay,
            returnCodeKessanDate,
          },
        };
      }
      const { managerSelected, manager, returnCodeManager } =
        this.businessInfoArea;
      if (this.personInChargeCopyPageId.includes(this.pageId)) {
        this.businessInfoAreaCopy = {
          ...this.businessInfoAreaCopy,
          ...{
            managerSelected,
            manager,
            returnCodeManager,
          },
        };
      }
    },
    //#endregion
  },
};
</script>

<style scoped>
.popup p:empty + .frm-row.frm-row-margin-top {
  margin-top: 20px;
}
#treatmentTarget label:nth-child(2) {
  width: 100px;
}
#ProcessingPartition label:nth-child(2) {
  width: 100px;
}
</style>
